module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8019.4103e5b8.png";